import React from 'react';
import RoleService from '../Services/roleService';
import FaIcon from './FaIcon';

class ColButton extends React.Component {
  static defaultProps = {
    text: 'Cancel',
    onClick: () => {
      alert('Please, define the onClick method.');
    },
    type: 'button',
    disabled: false,
    icon: 'fa-solid fa-circle-xmark',
    iconClassName: 'text-light',
    spinning: false,
    roleKey: '',
    className: 'col-sm-12 col-md-6 col-lg mt-1',
  };

  render() {
    const icn = this.props.disabled ? '' : this.props.iconClassName;
    const hasRole =
      !this.props.roleKey || (this.props.roleKey && RoleService.CheckUserPermission('colButton', this.props.roleKey));
    return (
      <div className={this.props.className}>
        <button
          className={'form-control form-control-orange'}
          type={this.props.type}
          disabled={this.props.disabled || this.props.spinning || !hasRole}
          onClick={this.props.type === 'button' ? this.props.onClick : null}
        >
          <FaIcon
            iconName={this.props.icon + (this.props.spinning ? ' fa-spin' : '')}
            className={icn}
            disabled={this.props.disabled || this.props.spinning || !hasRole}
          />{' '}
          {this.props.text}
        </button>
      </div>
    );
  }
}

export default ColButton;
